import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForJsmPersonalisedStandardToPremium(
	context: EditionAwarenessContextType,
): boolean {
	const {
		edition,
		product,
		isInTrial,
		isInPredunning,
		userRoles,
		hasDismissedButton,
		onDismissButton,
		isEligibleForJsmStandardToPremium,
	} = context;

	return Boolean(
		fg('jsm_edition_awareness_premium_upsell') &&
		isProductOneOf(product, ['jira-service-management']) &&
		isEditionOneOf(edition, ['standard']) &&
		isEligibleForJsmStandardToPremium &&
		userRoles?.includes('SITE_ADMIN') &&
		!isInTrial &&
		!isInPredunning &&
		hasDismissedButton === false &&
		typeof onDismissButton === 'function',
	);
}
